import { Injectable, isDevMode } from '@angular/core';

interface LogMeta {
  [key: string]: unknown;
}

@Injectable({ providedIn: 'root' })
export class LoggerService {
  info(event: string, meta?: LogMeta): void {
    const entry = this.buildEntry('info', event, meta);
    if (isDevMode()) {
      console.info(JSON.stringify(entry));
    }
    // In production, structured log entries go to CloudWatch via the browser
    // or are captured by error monitoring (no PII in logs)
  }

  warn(event: string, meta?: LogMeta): void {
    const entry = this.buildEntry('warn', event, meta);
    console.warn(JSON.stringify(entry));
  }

  error(event: string, error?: unknown, meta?: LogMeta): void {
    const entry = this.buildEntry('error', event, {
      ...meta,
      // Never log tokens, passwords, or PII — only error type and message
      errorType: error instanceof Error ? error.name : typeof error,
      errorMessage: error instanceof Error ? error.message : String(error),
    });
    console.error(JSON.stringify(entry));
  }

  private buildEntry(level: string, event: string, meta?: LogMeta): Record<string, unknown> {
    return {
      level,
      event,
      ts: new Date().toISOString(),
      app: 'mfr-frontend',
      ...meta,
    };
  }
}
